export const UNICODE_LTR_ISOLATE = '\u2066' //tells text to go LTR regardless if text is RTL
